export default "__VITE_ASSET__IsLo2jkq__"